import { render } from "./microphone.svg?vue&type=template&id=203db92f"
const script = {}
script.render = render

export default script